export var getTooltipDataHook = function getTooltipDataHook() {
  var baseDataHook = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'infoicon-';
  return "".concat(baseDataHook, "-tooltip");
};